import BasicTabs from "../Trials/BasicTabs";
import MainAccordion from "../Accordion/MainAccordion";

const VisitTabAccordion = ({
  setMessage,
  setTypeOfMessage,
  setModalVisitChangeShow,
  handleSelectingVisit,
  value,
  setValue,
  surveyFormBool,
  setSurveyFormBool,
  consentFormBool,
  setConsentFormBool,
  numberOfVisitsArray,
  setNumberOfVisitsArray,
  isEvent,
  setAddNewSurvey,
  allSurveys,
  selectedTrialType,
}) => {
  return (
    <MainAccordion
      title="Trial Visit & Source Document"
      data={
        <BasicTabs
          value={value}
          setValue={setValue}
          numberOfVisitsArray={numberOfVisitsArray}
          setNumberOfVisitsArray={setNumberOfVisitsArray}
          setMessage={setMessage}
          setTypeOfMessage={setTypeOfMessage}
          setModalVisitChangeShow={setModalVisitChangeShow}
          allSurveys={allSurveys}
        />
      }
    />
  );
};
export default VisitTabAccordion;
